import { processSplash } from '../processSplash';

import css from './assets/yellowLine.css';
import html from './assets/yellowLine.html';

export const yellowLine = processSplash(html, css);
